<template>
  <div class="tabsAccounts-content margin-general">
    <div class="tabs-wrapper">
      <div class="buttonsContainer" ref="buttonsContainer">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          class="buttonItem"
          :class="{ selected: selected === tab.value }"
          @click="selectTab(tab.value)"
        >
          {{ $t(tab.label) }}
        </button>

        <span class="selected-border" :style="borderStyle">
          <div class="border-style"></div>
        </span>
      </div>
    </div>
    <div class="no-results-mobile">
      <InputSearch
        id="lot-size-options"
        v-model="market"
        name="lot-size-dropdown"
        :label="$t('calculator-suite.calculatorSuite')"
        :placeholder="$t('calculator-suite.tabs.placeholder')"
        :model-value="market"
        :options="
          tabs.map((i) => ({
            text: i.label,
            value: i.value,
          }))
        "
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, watch } from "vue";
import InputSearch from "../InputSearch.vue";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["tab-selected"]);
const { t } = useI18n();
const props = defineProps({
  isVisible: Boolean,
});

const market = ref();
let tabs = ref([
  { value: "lotsize", label: t("calculator-suite.tabs.lotsize") },
  { value: "master", label: t("calculator-suite.tabs.master") },
  { value: "currency", label: t("calculator-suite.tabs.currency") },
  { value: "fibonacci", label: t("calculator-suite.tabs.fibonacci") },
  { value: "pivot", label: t("calculator-suite.tabs.pivot") },
]);

const selected = ref(tabs.value[0].value);
const selectedButtonIndex = ref(0);
const borderStyle = ref({});
const buttonsContainer = ref(null);

function selectTab(tabName) {
  const newIndex = tabs.value.findIndex((tab) => tab.value === tabName);
  if (newIndex !== -1) {
    selected.value = tabName;
  }
  selectedButtonIndex.value = newIndex;
  updateBorderBottomStyle();
  emit("tab-selected", tabName);
}

function initializeBorderBottomStyle() {
  const button =
    buttonsContainer?.value?.children?.[selectedButtonIndex?.value];
  if (button) {
    borderStyle.value = {
      width: `${button.offsetWidth}px`,
      left: `${button.offsetLeft}px`,
    };
  }
}

function updateBorderBottomStyle() {
  const button =
    buttonsContainer?.value?.children?.[selectedButtonIndex?.value];
  if (button) {
    borderStyle.value = {
      width: `${button.offsetWidth}px`,
      left: `${button.offsetLeft}px`,
    };
  }
}

onMounted(() => {
  initializeBorderBottomStyle();
  nextTick(() => {
    if (props.isVisible) {
      updateBorderBottomStyle();
    }
  });
});

// Watch para sincronizar el InputSearch con el activeTab
watch(market, (newValue) => {
  selectTab(newValue);
});
</script>
